import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import ImagePreviewModal from "@/components/ui/modals/ImagePeviewModal.vue";
  import { isImage, previewIcon } from "@/helpers/documents";
  import { downloadFile } from "@/helpers/downloadFile";

  interface Classes {
    container?: string;
    preview?: string;
  }
  interface Props {
    link: string;
    name: string;
    classes?: Classes;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentItemWithSlot',
  props: {
    link: {},
    name: {},
    classes: { default: () => ({
      container: "document-item-container",
      preview: "document-item--preview",
    }) }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const showImg = ref<string | undefined>(undefined);

  function openFile() {
    if (isImage(props.name || props.link)) {
      showImg.value = props.link;
    } else {
      window.open(props.link, "_blank");
    }
  }
  function download() {
    downloadFile(props.link);
  }

const __returned__ = { props, showImg, openFile, download, ref, ImagePreviewModal, get isImage() { return isImage }, get previewIcon() { return previewIcon }, get downloadFile() { return downloadFile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})